import React, { Component } from "react";
import moment from "moment";
import { Box } from "@material-ui/core";

import HUBContext from "../../../services/HUBContext";
import CompanyParamProvider from "../../../providers/CompanyParamProvider";
import { ROUTER_MAP_PATH } from "../../../EmbeddedRoutes";
import { EmbeddedPage } from "../../../layouts";
import VehicleTableCardWidget from "../widgets/VehicleTableCardWidget/VehicleTableCardWidget";

class VehicleTablePage extends Component {
  render() {
    return (
      <EmbeddedPage>
        <CompanyParamProvider>
          <Box sx={{ flex: 1 }}>
            <VehicleTableCardWidget
              filters={{
                startDate: moment().format("YYYYMMDD"),
                endDate: moment().format("YYYYMMDD"),
              }}
              stateuid={"123"}
              dashboardHandler={{
                breakpoint: null,
                reset: () => console.log("Reset dasboard layout"),
                getState: () => ({}),
                changeCurrentLayout: () => ({}),
              }}
              widget={{
                dashboardWidgetID: 0,
                apiRoute: "vehicles-v2",
                componentKey: "vehicles-v2-table",
                title: "Veículos adicionados",
                urlRequest:
                  "/api/v1/Dashboard/data/widgetDatav3/vehicles-v2-table",
                chartType: "vehicles-v2-table",
                dateCalc: "currentMonth",
              }}
              editUrl={ROUTER_MAP_PATH.vehicles.editPage?.replace(
                ":cid",
                ":companyID",
              )}
              reviewUrl={ROUTER_MAP_PATH.vehicles.reviewPage?.replace(
                ":cid",
                ":companyID",
              )}
            />
          </Box>
        </CompanyParamProvider>
      </EmbeddedPage>
    );
  }
}

VehicleTablePage.contextType = HUBContext;
export default VehicleTablePage;
